
import WarningTestModalComponent from "@/components/Modals/WarningTestModal/WarningTestModalComponent";
export default WarningTestModalComponent;
